import { Trip } from "../Trip/Trip";
import { VehicleReservation } from "../VehicleReservation/VehicleReservation";

export class Vehicle{

    vehicletypeid:number;
    vehicletypename:string;
    vehicleid:any;
    capacity : number;
    contracted:number;
    remainingSeats:number;
    make: string;
    model: string;
    year: number;
    driverid: number | null;
    /** When assigned driver is portal-only, API may send `driverid` null and use these instead. */
    driver_kind?: string;
    portal_driver_id?: number | null;
    vehicle_name?: string;
    driverfirstname:string;
    platenumber:string;
    driverlastname:string;
    available:boolean;
    runtimeid;
    companyid:number;
    company_location_id:number;
    shifts:Array<any>;
    //vehicleReservation: VehicleReservation;

    constructor(vehicle:VehicleProperties){

        if(vehicle){
            this.capacity = vehicle.capacity;
            this.remainingSeats = this.capacity;
            this.vehicletypeid = vehicle.vehicletypeid
            this.vehicleid = vehicle.vehicleid;
            this.vehicletypename = vehicle.vehicletypename;
            this.contracted = vehicle.contracted;
            this.platenumber = vehicle.platenumber ? vehicle.platenumber : null;
            this.make = vehicle.make;
            this.model = vehicle.model;
            this.driverid = vehicle.driverid;
            if (vehicle.driver_kind != null) {
                this.driver_kind = vehicle.driver_kind;
            }
            if (vehicle.portal_driver_id != null) {
                this.portal_driver_id = vehicle.portal_driver_id;
            }
            if (vehicle.vehicle_name != null) {
                this.vehicle_name = vehicle.vehicle_name;
            }
            this.driverfirstname = vehicle.driverfirstname,
            this.driverlastname = vehicle.driverlastname,
            this.year = vehicle.year;
            this.available = vehicle.available;
            this.companyid = vehicle.companyid;
            this.shifts = vehicle.shifts;
            this.company_location_id = vehicle.company_location_id;
            if(vehicle.runtimeid){
                this.runtimeid = vehicle.runtimeid;
            }
        }
    }

    public recalculateSeats(trip:Trip){

        this.remainingSeats = this.capacity;
        this.remainingSeats -= trip.passengers.length;
    }

    public static isContracted(vehicle:Vehicle){
        if(vehicle.make == 'CONTRACTED' && vehicle.model == 'CONTRACTED'){
            return true;
        }else{
            return false;
        }
    }

    public static convertVehicleResponseToVehicles(vehicleResponse: Array<any>): Array<Vehicle> {

        var vehilces = new Array<Vehicle>();
        vehicleResponse.forEach(vehicle => {

            vehilces.push(new Vehicle(vehicle));
        });
        return vehilces;
    }

    copy<T>(copyTo:T){
        var copy = JSON.parse(JSON.stringify(this));
        var objectCopy:T = Object.assign(copyTo,copy);
        return objectCopy;
    }

    print(){
        console.log(`I am a ${this.year} ${this.make} ${this.model}`);
    }

}

export interface VehicleProperties{
    vehicletypeid:number;
    vehicletypename?:string;
    vehicleid:any;
    capacity : number;
    remainingSeats:number;
    contracted:number;
    make: string;
    model: string;
    year: number;
    driverid: number | null;
    driver_kind?: string;
    portal_driver_id?: number | null;
    vehicle_name?: string;
    driverfirstname:string;
    driverlastname:string;
    available:boolean;
    platenumber?:string;
    runtimeid;
    companyid:number;
    company_location_id:number;
    shifts:Array<any>
}